import { CheckCircleFilled } from '@ant-design/icons';
import * as React from 'react';
import { IconColor } from './IconColor';

export interface CheckedSuccessProps
  extends React.HTMLAttributes<HTMLSpanElement> {}

export function CheckedSuccess(props: CheckedSuccessProps) {
  return (
    <IconColor type="success">
      <CheckCircleFilled />
    </IconColor>
  );
}
